import { useQuery } from 'react-query';
import { chamarOktonBank } from '../oktonbank';

// Nomes das colunas de extratobancario. conciliado_exb é '0' ou '1', não
// booleano: é o que o MySQL devolve.
export interface LancamentoExtrato {
  id_exb: string;
  filial_exb: string;
  conta_exb: string;
  // 'yyyy-MM-dd HH:mm:ss'. A hora é a que o banco informou; 00:00:00 quando
  // ele não informa (ou lançamento manual sem hora).
  data_exb: string;
  descricao_exb: string;
  valor_exb: string;
  referencia_exb: string | null;
  // FITID como o banco mandou no OFX. Só rastreio: quem deduplica é a
  // referencia_exb.
  fitid_exb: string | null;
  conciliado_exb: string;
  descricao_cts: string | null;
}

interface IResponseData {
  rows: LancamentoExtrato[];
}

async function getExtratoBancario(
  idConta?: string,
  status: 'pending' | 'all' = 'pending',
  dataIni = '',
  dataFim = '',
): Promise<LancamentoExtrato[]> {
  const dados = await chamarOktonBank<IResponseData>('OBExtrato', 'listar', {
    conta: idConta || '',
    status,
    dataini: dataIni,
    datafim: dataFim,
  });
  return Array.isArray(dados?.rows) ? dados.rows : [];
}

// Por padrão traz só os ainda não conciliados; status='all' inclui os demais.
export function useExtratoBancario(
  idConta?: string,
  status: 'pending' | 'all' = 'pending',
  dataIni = '',
  dataFim = '',
  habilitado = true,
) {
  return useQuery(
    ['extrato-bancario', idConta ?? '', status, dataIni, dataFim],
    () => getExtratoBancario(idConta, status, dataIni, dataFim),
    { enabled: habilitado },
  );
}
